import { useCallback, useState } from "react";
import { useGetAccountPaymentPrefsQuery } from "../../../../graphql/supergraph.index";
import { clientContext } from "../../../../utils/graphql_utils";
import { usePositionListOfAccountWithoutPaymentPref } from "../../Components/PositionList/usePositionListOfAccountWithoutPaymentPref";

export const useAccountPaymentPrefController = ({ accountId }: { accountId: string }) => {
  const {
    data: accountPaymentPrefsData,
    loading: accountPaymentPrefsLoading,
    error: accountPaymentPrefsError,
    refetch: refetchAccountPaymentPrefs,
  } = useGetAccountPaymentPrefsQuery({
    variables: {
      accountId,
      includeDeleted: true,
    },
    context: clientContext(),
  });

  const {
    positionsPaginated,
    handleLoadMorePositions,
    positionListLoading,
    positionListError,
    refetchPositionList,
  } = usePositionListOfAccountWithoutPaymentPref({ id: accountId });

  const [createPaymentPrefId, setCreatePaymentPrefId] = useState<string | undefined>(undefined);

  const refetchData = useCallback(async () => {
    await refetchAccountPaymentPrefs();
    await refetchPositionList();
  }, [refetchAccountPaymentPrefs, refetchPositionList]);

  const handleSuccessCreatePaymentPref = async () => {
    await refetchData();
    setCreatePaymentPrefId(undefined);
  };

  const [editPaymentPrefId, setEditPaymentPrefId] = useState<string | undefined>(undefined);

  const handleSuccessEditPaymentPref = async () => {
    await refetchData();
    setEditPaymentPrefId(undefined);
  };

  const canEdit =
    accountPaymentPrefsData?.currentUser?.canEditPaymentPrefsForAccountPermission ?? false;
  const canReveal =
    accountPaymentPrefsData?.currentUser?.canRevealPaymentPrefPermission ?? false;

  return {
    dataLoading: accountPaymentPrefsLoading || positionListLoading,
    dataError: accountPaymentPrefsError || positionListError,
    accountPaymentPrefsData,
    positionsPaginated,
    handleLoadMorePositions,
    handleCreatePaymentPrefClick: setCreatePaymentPrefId,
    showCreatePaymentPref: createPaymentPrefId !== undefined,
    createPaymentPrefId,
    handleCancelCreatePaymentPref: () => setCreatePaymentPrefId(undefined),
    handleSuccessCreatePaymentPref,
    handleEditPaymentPrefClick: setEditPaymentPrefId,
    showEditPaymentPref: editPaymentPrefId !== undefined,
    editPaymentPrefId,
    handleCancelEditPaymentPref: () => setEditPaymentPrefId(undefined),
    handleSuccessEditPaymentPref,
    showInstructionsNeededComponent: positionsPaginated?.count && positionsPaginated?.count > 0,
    refetchData,
    canEdit,
    canReveal,
  };
};
